import { render, staticRenderFns } from "./DropArea.vue?vue&type=template&id=c293fa52"
import script from "./DropArea.vue?vue&type=script&lang=js"
export * from "./DropArea.vue?vue&type=script&lang=js"
import style0 from "./DropArea.vue?vue&type=style&index=0&id=c293fa52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports